function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var _require = require('./script_validate'),
  evaluateWorkspaceStatus = _require.evaluateWorkspaceStatus;
var _require2 = require('./script_build'),
  lockingView = _require2.lockingView;
var PanelMenu = require('./panel_menu');
var _require3 = require('./unlock_tx_panel'),
  unlockInputRows = _require3.unlockInputRows,
  unlockOutputRows = _require3.unlockOutputRows,
  unlockTransactionPanelMarkup = _require3.unlockTransactionPanelMarkup;
var _require4 = require('./unlock_tx_edit'),
  removeOutputAt = _require4.removeOutputAt;
var PanelReferenceView = /*#__PURE__*/function () {
  function PanelReferenceView(app, mod) {
    _classCallCheck(this, PanelReferenceView);
    this.app = app;
    this.mod = mod;
    this.container = null;
    this.lastContext = null;
  }
  return _createClass(PanelReferenceView, [{
    key: "mount",
    value: function mount(container) {
      this.container = container;
    }
  }, {
    key: "render",
    value: function render() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.container) {
        return;
      }
      this.lastContext = context;
      var phase = context.phase || 'script-help';
      var remaining = Number(context.remainingCount) || 0;
      var items = this.buildItems(phase, remaining);
      var ref = this.container.querySelector(':scope > .rs-panel-ref');
      if (!ref) {
        ref = document.createElement('div');
        this.container.appendChild(ref);
      }
      ref.className = "rs-panel-ref rs-panel-ref-".concat(phase);
      ref.innerHTML = "\n      <ul class=\"rs-panel-ref-list\">\n        ".concat(items.join(''), "\n      </ul>\n    ");
      this.bindEvents();
    }
  }, {
    key: "buildItems",
    value: function buildItems(phase, remaining) {
      var fieldLabel = remaining === 1 ? 'field' : 'fields';
      var countText = "<span class=\"rs-panel-ref-count\">".concat(remaining, "</span> ").concat(fieldLabel, " remaining");
      if (phase === 'required-help') {
        return ["<li class=\"rs-panel-ref-status-text\">".concat(countText, "</li>")];
      }
      if (phase === 'required-complete') {
        var _this$mod;
        var isUnlock = ((_this$mod = this.mod) === null || _this$mod === void 0 ? void 0 : _this$mod.workflow) === 'unlock';
        var action = isUnlock ? 'unlock-solution' : 'publish';
        var label = isUnlock ? 'spend script' : 'use script';
        return ["<li class=\"rs-panel-ref-ready-banner\" role=\"status\">\n          <div class=\"rs-panel-ref-ready-banner-inner\">your script is ready</div>\n        </li>", '<li class="rs-panel-ref-ready-prompt">What would you like to do now?</li>', "<li class=\"rs-panel-ref-actions rs-panel-ref-actions-stack\">\n          <button type=\"button\" class=\"rs-btn rs-btn-primary rs-panel-ref-action rs-panel-ref-action-publish\" data-action=\"".concat(action, "\">").concat(label, "</button>\n          <button type=\"button\" class=\"saito-text-link rs-panel-ref-save-later\" data-action=\"save-later\">or save for later...</button>\n        </li>")];
      }
      if (phase === 'script-ready') {
        return ["<li class=\"rs-panel-ref-ready-banner\" role=\"status\">\n          <div class=\"rs-panel-ref-ready-banner-inner\">your script is ready</div>\n        </li>", "<li class=\"rs-panel-ref-ready-copy\">\n          Scripts control who can spend digital assets. The next step is to specify whether you want your script to protect a SAITO balance or an NFT.\n        </li>", "<li class=\"rs-panel-ref-actions rs-panel-ref-actions-stack\">\n          <button type=\"button\" class=\"rs-btn rs-btn-primary rs-panel-ref-action rs-panel-ref-action-publish\" data-action=\"publish\">Choose Asset to Protect</button>\n          <button type=\"button\" class=\"saito-text-link rs-panel-ref-action\" data-action=\"move-to-testing\">or test this script\u2026</button>\n          <button type=\"button\" class=\"saito-text-link rs-panel-ref-save-later\" data-action=\"save-later\">or save for later...</button>\n        </li>"];
      }
      return ["<li>".concat(countText, "</li>")];
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this$container,
        _this = this,
        _this$container2,
        _this$container3,
        _this$container4;
      (_this$container = this.container) === null || _this$container === void 0 || (_this$container = _this$container.querySelector('[data-action="move-to-testing"]')) === null || _this$container === void 0 || _this$container.addEventListener('click', function () {
        var _this$lastContext;
        if (typeof ((_this$lastContext = _this.lastContext) === null || _this$lastContext === void 0 ? void 0 : _this$lastContext.onMoveToTesting) === 'function') {
          _this.lastContext.onMoveToTesting();
        }
      });
      (_this$container2 = this.container) === null || _this$container2 === void 0 || (_this$container2 = _this$container2.querySelector('[data-action="publish"]')) === null || _this$container2 === void 0 || _this$container2.addEventListener('click', function () {
        var _this$lastContext2;
        if (typeof ((_this$lastContext2 = _this.lastContext) === null || _this$lastContext2 === void 0 ? void 0 : _this$lastContext2.onPublish) === 'function') {
          _this.lastContext.onPublish();
        }
      });
      (_this$container3 = this.container) === null || _this$container3 === void 0 || (_this$container3 = _this$container3.querySelector('[data-action="save-later"]')) === null || _this$container3 === void 0 || _this$container3.addEventListener('click', function () {
        var _this$lastContext3;
        if (typeof ((_this$lastContext3 = _this.lastContext) === null || _this$lastContext3 === void 0 ? void 0 : _this$lastContext3.onSaveLater) === 'function') {
          _this.lastContext.onSaveLater();
        }
      });
      (_this$container4 = this.container) === null || _this$container4 === void 0 || (_this$container4 = _this$container4.querySelector('[data-action="unlock-solution"]')) === null || _this$container4 === void 0 || _this$container4.addEventListener('click', function () {
        var _this$lastContext4;
        if (typeof ((_this$lastContext4 = _this.lastContext) === null || _this$lastContext4 === void 0 ? void 0 : _this$lastContext4.onUnlockSolution) === 'function') {
          _this.lastContext.onUnlockSolution();
        }
      });
    }
  }]);
}();
var RustscriptPanel = /*#__PURE__*/function () {
  function RustscriptPanel(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var main = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, RustscriptPanel);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.main = main;
    this.referenceView = new PanelReferenceView(app, mod);
  }
  return _createClass(RustscriptPanel, [{
    key: "render",
    value: function render() {
      var _status$script$placeh,
        _status$script$placeh2,
        _status$required$plac,
        _status$required$plac2,
        _this2 = this;
      var el = document.querySelector(this.container);
      if (!el || !this.main) {
        return;
      }
      el.innerHTML = '';
      this.referenceView.mount(el);
      var locking = lockingView(deepClone(this.mod.getScript()));
      var unlocking = this.main.testingUnlocked ? this.mod.getScript() : {};
      var status = evaluateWorkspaceStatus(locking, unlocking, this.main.executionStatus, this.mod.opcodes);
      var remainingScript = (_status$script$placeh = (_status$script$placeh2 = status.script.placeholders) === null || _status$script$placeh2 === void 0 ? void 0 : _status$script$placeh2.length) !== null && _status$script$placeh !== void 0 ? _status$script$placeh : 0;
      var remainingRequired = (_status$required$plac = (_status$required$plac2 = status.required.placeholders) === null || _status$required$plac2 === void 0 ? void 0 : _status$required$plac2.length) !== null && _status$required$plac !== void 0 ? _status$required$plac : 0;
      var scriptReady = status.script.state === 'ready';
      var showMoveToTesting = !this.main.testingUnlocked && scriptReady;
      var testLive = this.main.testingUnlocked && scriptReady;
      var phase = 'script-help';
      if (testLive) {
        phase = this.main.executionStatus.success === true ? 'required-complete' : 'required-help';
      } else if (showMoveToTesting) {
        phase = 'script-ready';
      }
      if (this.shouldRenderUnlockTransactionPanel(testLive)) {
        this.renderUnlockTransactionPanel(el);
        return;
      }
      if (PanelMenu.shouldShowForWitnessPanel(phase)) {
        var _this$main;
        el.insertAdjacentHTML('afterbegin', "<header class=\"rs-panel-header rs-panel-header-status\">".concat(PanelMenu.markup('witness'), "</header>"));
        (_this$main = this.main) === null || _this$main === void 0 || _this$main.bindPanelMenu(el, 'witness');
      }
      this.referenceView.render({
        phase: phase,
        remainingCount: testLive ? remainingRequired : remainingScript,
        onMoveToTesting: function onMoveToTesting() {
          return _this2.moveToTesting();
        },
        onPublish: function onPublish() {
          return _this2.openPublish();
        },
        onSaveLater: function onSaveLater() {
          return _this2.openSaveLater();
        },
        onUnlockSolution: function onUnlockSolution() {
          return _this2.openUnlockSolution();
        }
      });
    }
  }, {
    key: "shouldRenderUnlockTransactionPanel",
    value: function shouldRenderUnlockTransactionPanel(testLive) {
      var _this$mod2;
      return ((_this$mod2 = this.mod) === null || _this$mod2 === void 0 ? void 0 : _this$mod2.workflow) === 'unlock' && !!testLive;
    }
  }, {
    key: "renderUnlockTransactionPanel",
    value: function renderUnlockTransactionPanel(el) {
      var _this$main$selectedUn,
        _this$main2,
        _el$querySelector,
        _this3 = this;
      el.innerHTML = unlockTransactionPanelMarkup({
        inputs: unlockInputRows(this.app, this.mod),
        outputs: unlockOutputRows(this.app, this.mod),
        selectedInputIndex: (_this$main$selectedUn = (_this$main2 = this.main) === null || _this$main2 === void 0 ? void 0 : _this$main2.selectedUnlockInputIndex) !== null && _this$main$selectedUn !== void 0 ? _this$main$selectedUn : null,
        mod: this.mod
      });
      (_el$querySelector = el.querySelector('[data-action="set-fee"]')) === null || _el$querySelector === void 0 || _el$querySelector.addEventListener('click', function () {
        var _this3$main, _this3$main$open;
        (_this3$main = _this3.main) === null || _this3$main === void 0 || (_this3$main = _this3$main.unlockFeeFlow) === null || _this3$main === void 0 || (_this3$main$open = _this3$main.open) === null || _this3$main$open === void 0 || _this3$main$open.call(_this3$main);
      });
      el.querySelectorAll('.rs-tx-input[data-input-index]').forEach(function (card) {
        var activate = function activate() {
          var index = Number(card.dataset.inputIndex) || 0;
          var kind = card.dataset.kind === 'nft' ? 'nft' : 'saito';
          _this3.selectUnlockInput(index, kind);
        };
        card.addEventListener('click', activate);
        card.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate();
          }
        });
      });
      el.querySelectorAll('.rs-tx-output[role="button"]').forEach(function (card) {
        var activate = function activate() {
          var index = Number(card.dataset.outputIndex);
          _this3.confirmDeleteUnlockOutput(index);
        };
        card.addEventListener('click', activate);
        card.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate();
          }
        });
      });
    }
  }, {
    key: "selectUnlockInput",
    value: function selectUnlockInput(index, kind) {
      var _this$main3;
      var _require5 = require('./unlock_tx_fee'),
        isUnlockEditable = _require5.isUnlockEditable,
        UNLOCK_SIGNED_ERROR = _require5.UNLOCK_SIGNED_ERROR;
      if (!isUnlockEditable(this.mod)) {
        window.alert(UNLOCK_SIGNED_ERROR);
        return;
      }
      if (this.main) {
        this.main.selectedUnlockInputIndex = index;
      }
      this.render();
      (_this$main3 = this.main) === null || _this$main3 === void 0 || (_this$main3 = _this$main3.spendOutputFlow) === null || _this$main3 === void 0 || _this$main3.openForInput({
        kind: kind,
        inputIndex: index
      });
    }
  }, {
    key: "confirmDeleteUnlockOutput",
    value: function confirmDeleteUnlockOutput(index) {
      if (!Number.isInteger(index) || index < 0) {
        return;
      }
      var _require6 = require('./unlock_tx_fee'),
        isUnlockEditable = _require6.isUnlockEditable,
        UNLOCK_SIGNED_ERROR = _require6.UNLOCK_SIGNED_ERROR;
      if (!isUnlockEditable(this.mod)) {
        window.alert(UNLOCK_SIGNED_ERROR);
        return;
      }
      if (!window.confirm('Delete this output?')) {
        return;
      }
      try {
        if (removeOutputAt(this.mod, index, this.main)) {
          var _this$main4, _this$main4$refresh;
          this.render();
          (_this$main4 = this.main) === null || _this$main4 === void 0 || (_this$main4$refresh = _this$main4.refresh) === null || _this$main4$refresh === void 0 || _this$main4$refresh.call(_this$main4, {
            skipTestSync: true
          });
        }
      } catch (err) {
        window.alert((err === null || err === void 0 ? void 0 : err.message) || String(err));
      }
    }
  }, {
    key: "moveToTesting",
    value: function () {
      var _moveToTesting = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.main.testingUnlocked = true;
              _context.n = 1;
              return this.main.refresh();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function moveToTesting() {
        return _moveToTesting.apply(this, arguments);
      }
      return moveToTesting;
    }()
  }, {
    key: "openPublish",
    value: function openPublish() {
      var _this$main5;
      if ((_this$main5 = this.main) !== null && _this$main5 !== void 0 && _this$main5.publishFlow && this.main.isScriptPublishable()) {
        this.main.publishFlow.openChoice();
      }
    }
  }, {
    key: "openSaveLater",
    value: function openSaveLater() {
      try {
        var scriptPayload = this.mod.getScript();
        this.mod.exportScriptDraft(scriptPayload);
      } catch (_err) {
        /* export failed */
      }
    }
  }, {
    key: "openUnlockSolution",
    value: function openUnlockSolution() {
      var _this$main6;
      if ((_this$main6 = this.main) !== null && _this$main6 !== void 0 && _this$main6.unlockFlow && this.mod.workflow === 'unlock') {
        this.main.unlockFlow.openSolution();
      }
    }
  }]);
}();
function deepClone(value) {
  return JSON.parse(JSON.stringify(value));
}
module.exports = RustscriptPanel;